import toast from "react-hot-toast";
import {
  createTopupOrder,
  verifyTopupPayment,
} from "../../api/context/billing";
import { loadRazorpay } from "../../utils/loadRazorpay";

const getPrefill = () => {
  const user = JSON.parse(localStorage.getItem("user")) || {};
  const name = [user?.firstName, user?.lastName].filter(Boolean).join(" ");
  return {
    email: user?.email || "",
    name: name || user?.email || "",
  };
};

export const buyTopupPack = async (packCode, { onSuccess, onDismiss } = {}) => {
  const sdkReady = await loadRazorpay();
  if (!sdkReady) {
    toast.error("Payment gateway failed to load. Check your connection.");
    return;
  }

  let orderData;
  try {
    const res = await createTopupOrder(packCode);
    orderData = res?.data?.data;
    if (!orderData?.order?.id) {
      toast.error(res?.data?.message || "Could not create order");
      return;
    }
  } catch (err) {
    toast.error(err?.response?.data?.message || "Could not create order");
    return;
  }

  const { order, pack, razorpayKeyId } = orderData;
  const prefill = getPrefill();

  const rzp = new window.Razorpay({
    key: razorpayKeyId,
    order_id: order.id,
    amount: order.amount,
    currency: order.currency,
    name: "Getto — AI Listing Top-up",
    description: `${pack.listingCount} AI credits`,
    prefill,
    theme: { color: "#008695" },
    handler: async (paymentResponse) => {
      try {
        await verifyTopupPayment(paymentResponse);
        toast.success(`${pack.listingCount} credit${pack.listingCount === 1 ? "" : "s"} added to your wallet.`);
        if (onSuccess) onSuccess();
      } catch (err) {
        toast.error(
          err?.response?.data?.message ||
            "Payment received but verification failed. Please refresh."
        );
      }
    },
    modal: {
      ondismiss: () => {
        toast("Payment cancelled");
        if (onDismiss) onDismiss();
      },
    },
  });
  rzp.open();
};
